// extracted by mini-css-extract-plugin
module.exports = {"group":"FormGroup-group-1rseT","extraSmall":"FormGroup-extraSmall-3Qwc_","small":"FormGroup-small-1F_0h","medium":"FormGroup-medium-22QEI","large":"FormGroup-large-2yWgp"};